import { HolderOutlined, CloseOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Typography, Space, Flex } from 'antd';

import type { SortableIntegrationItemProps } from '@app/pages/Notifications/components/RecordsPriorityIntegration/types';
import { SocialIntegrationIcon } from '@app/shared/ui/SocialIntegrationIcon';

const { Text } = Typography;

export const SortableIntegrationItem = ({
  integration,
  data,
  setDefaultIntegrations,
}: SortableIntegrationItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: integration.Id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const currentIntegration = data?.AllowedIntegrations?.find(
    (item) => item.Id === integration.Id
  );

  if (!currentIntegration) {
    return;
  }

  const handleDeleteIntegration = (id: number) => {
    setDefaultIntegrations((prev) => {
      const filteredArray = prev.filter((integration) => integration.Id !== id);
      return filteredArray.map((item, index) => ({
        ...item,
        Order: index,
      }));
    });
  };

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        padding: '12px',
        marginBottom: '8px',
        backgroundColor: isDragging ? '#f0f0f0' : 'white',
        border: '1px solid #d9d9d9',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'grab',
        touchAction: 'none',
      }}
    >
      <Space align="center" size="middle">
        <Text type="secondary" style={{ fontSize: '12px' }}>
          {integration.Order + 1}
        </Text>
        <div
          {...attributes}
          {...listeners}
          style={{
            padding: '4px',
            color: '#999',
            cursor: 'grab',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <HolderOutlined />
        </div>

        <Flex align="center" gap={8}>
          <SocialIntegrationIcon
            type={currentIntegration.SocialType}
            size="lg"
          />
          <Text
            strong
            ellipsis={{ tooltip: currentIntegration.Name }}
            style={{ fontSize: 14, maxWidth: 260 }}
          >
            {currentIntegration.Name}
          </Text>
        </Flex>
      </Space>

      <Button
        type="text"
        size="small"
        icon={<CloseOutlined style={{ color: '#ff4d4f', fontSize: '12px' }} />}
        style={{
          width: '24px',
          height: '24px',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={() => {
          handleDeleteIntegration(integration.Id);
        }}
      />
    </div>
  );
};
